module.exports = __webpack_public_path__ + "img/s-hd.85402b7b.jpg";